import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isValidateTimeRecordsUpToDateRequestFailure({ uuid }) {
      const req = getState().find(({ project }) => uuid === project.uuid);

      return req ? req.request.isFailure : false;
    },
    isValidateTimeRecordsUpToDateRequestPending({ uuid }) {
      const req = getState().find(({ project }) => uuid === project.uuid);

      return req ? req.request.isPending : false;
    },
    isValidateTimeRecordsUpToDateRequestSuccess({ uuid }) {
      const req = getState().find(({ project }) => uuid === project.uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
